const reportWebVitals = () => {
  return null;
};

export default reportWebVitals;
